/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function () {
    'use strict';
    var box = document.querySelector('[data-ug]');
    if (!box) { return; }
    var klucz = 'pewniaki:ulubiona-gra:v1';
    var wybor = box.querySelector('[data-ug-wybor]');
    var lista = box.querySelector('[data-ug-lista]');
    var karty = Array.prototype.slice.call(lista.children);
    var przycisk = box.querySelector('[data-ug-pokaz]');
    var status = box.querySelector('[data-ug-status]');
    var pusto = box.querySelector('[data-ug-pusto]');
    var en = document.documentElement.lang.indexOf('en') === 0;
    var wszystkie = true;
    var sprawdz = document.querySelector('[data-home-check]');
    function poprawna(gra) {
        return typeof gra === 'string' && Array.prototype.some.call(wybor.options, function (o) { return o.value === gra; });
    }
    function odczyt() {
        try {
            var d = JSON.parse(localStorage.getItem(klucz));
            if(d && d.v === 1 && poprawna(d.gra))return d.gra;
        } catch (e) { /* Bieżący widok działa także bez pamięci. */ }
        var S=window.PewniakiZestawy && window.PewniakiZestawy.sklep();
        var saved=S && S.gry().find(function(g){return poprawna(g) && S.lista(g).length;});
        return saved || (poprawna('lotto') ? 'lotto' : '');
    }
    function pokaz() {
        var gra = wybor.value;
        if(sprawdz){var url=new URL(sprawdz.href,location.href);if(gra)url.searchParams.set('gra',gra);else url.searchParams.delete('gra');sprawdz.href=url.pathname+url.search;}
        var pierwsza = karty.filter(function (k) { return k.getAttribute('data-ug-gra') === gra; })[0];
        if (pierwsza) { lista.appendChild(pierwsza); }
        karty.forEach(function (k) {
            if (k !== pierwsza) { lista.appendChild(k); }
            var wybrana = k === pierwsza;
            k.hidden = !!gra && !wszystkie && !wybrana;
            k.querySelector('[data-ug-termin]').hidden = !wybrana;
        });
        pusto.hidden = !gra || !!pierwsza;
        przycisk.hidden = !gra;
        przycisk.setAttribute('aria-expanded', wszystkie ? 'true' : 'false');
        (przycisk.querySelector('[data-ug-label]') || przycisk).textContent = wszystkie ? (jst("ulubiona_gra_js.39ef80351a37")) : (jst("ulubiona_gra_js.8412f2b0c4ed"));
    }
    wybor.addEventListener('change', function () {
        if (!poprawna(wybor.value)) { wybor.value = ''; }
        wszystkie = true;
        pokaz();
        try {
            if (wybor.value) {
                var tekst = JSON.stringify({ v: 1, gra: wybor.value });
                localStorage.setItem(klucz, tekst);
                if (localStorage.getItem(klucz) !== tekst) { throw new Error('zapis'); }
            } else { localStorage.setItem(klucz,JSON.stringify({v:1,gra:''})); }
            status.textContent = jst("ulubiona_gra_js.88a96b1e954c");
        } catch (e) {
            status.textContent = jst("ulubiona_gra_js.37a76050b266");
        }
    });
    przycisk.addEventListener('click', function () { wszystkie = !wszystkie; pokaz(); });
    window.addEventListener('storage', function (e) {
        if (e.key === klucz || e.key === null) { wybor.value = odczyt(); wszystkie = true; status.textContent = ''; pokaz(); }
    });
    wybor.value = odczyt();
    pokaz();
    var tekstStartowy = jst("ulubiona_gra_js.1106d4c9aa13");
    if (status.textContent !== tekstStartowy) { status.textContent = tekstStartowy; }
    box.querySelector('[data-ug-kontrolki]').hidden = false;
    box.setAttribute('data-ug-ready', '1');
})();
